import DigInRisk from './DigInRisk';

export default DigInRisk;
